import { MapPin } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { EntityConfig } from '../types';

export interface MasterLocation {
  id: string;
  code: string;
  display_name: string;
  country: string | null;
  is_active: boolean;
  sort_order: number;
  created_at: string;
}

export const masterLocationsConfig: EntityConfig<MasterLocation> = {
  name: 'masterLocations',
  singularName: 'Location',
  pluralName: 'Locations',
  tableName: 'master_locations',
  keyField: 'id',
  icon: <MapPin className="h-4 w-4" />,
  description: 'Location reference data',
  category: 'master',
  permissionModule: 'settings',

  columns: [
    {
      id: 'sort_order',
      header: 'Order',
      accessorKey: 'sort_order',
      sortable: true,
      width: '80px',
    },
    {
      id: 'code',
      header: 'Code',
      accessorKey: 'code',
      sortable: true,
      cell: (row) => <span className="font-mono text-sm">{row.code}</span>,
    },
    {
      id: 'display_name',
      header: 'Display Name',
      accessorKey: 'display_name',
      sortable: true,
    },
    {
      id: 'country',
      header: 'Country',
      accessorKey: 'country',
      cell: (row) => row.country || <span className="text-muted-foreground">-</span>,
    },
    {
      id: 'is_active',
      header: 'Status',
      accessorKey: 'is_active',
      width: '100px',
      cell: (row) => (
        <Badge variant={row.is_active ? 'default' : 'secondary'}>
          {row.is_active ? 'Active' : 'Inactive'}
        </Badge>
      ),
    },
  ],

  formFields: [
    {
      name: 'code',
      label: 'Code',
      type: 'text',
      required: true,
      placeholder: 'e.g., us_ny',
    },
    {
      name: 'display_name',
      label: 'Display Name',
      type: 'text',
      required: true,
      placeholder: 'e.g., New York, USA',
    },
    {
      name: 'country',
      label: 'Country',
      type: 'text',
      placeholder: 'e.g., USA',
    },
    {
      name: 'sort_order',
      label: 'Sort Order',
      type: 'number',
      defaultValue: 0,
    },
    {
      name: 'is_active',
      label: 'Active',
      type: 'switch',
      defaultValue: true,
    },
  ],

  searchFields: ['code', 'display_name', 'country'],
  defaultOrderBy: { field: 'sort_order', ascending: true },

  features: {
    canCreate: true,
    canUpdate: true,
    canDelete: true,
    canBulkDelete: false,
    showActivityLog: false,
  },
};
